import { render, staticRenderFns } from "./miniappPannelEdit.vue?vue&type=template&id=5498a9d1"
import script from "./miniappPannelEdit.vue?vue&type=script&lang=js"
export * from "./miniappPannelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports